import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Global } from '@services/core/Global';

@Injectable({ providedIn: 'root' })
export class DocumentTypeService {
  private http = inject(HttpClient);
  private url = Global.url;

  get(): Observable<any[]> {
    return this.http.get<any[]>(`${this.url}V1/document-types`);
  }

  create(data: any): Observable<any> {
    return this.http.post<any>(`${this.url}V1/document-types`, data);
  }

  update(slug: string, data: any, options?: { applyToOpen?: boolean }): Observable<any> {
    return this.http.put<any>(`${this.url}V1/process-documents/document-type/${slug}/status`, {
      ...data,
      applyToOpen: !!options?.applyToOpen
    });
  }
}
